import {reqPost, reqUpload} from "./request";

// 提供
export const provideSmsValidateCode = (param) => reqPost('/provide/smsValidateCode', param);
export const provideLocalFileUpload = (param) => reqPost('/provide/localFileUpload', param);

// 登录
export const authLogin = (param) => reqPost('/auth/login', param);
export const authLoginAccount = (param) => reqPost('/auth/loginAccount', param);

// 账号信息
export const accountDetail = (param) => reqPost('/account/detail', param);
export const accountLogout = (param) => reqPost('/account/logout', param);

// 生码记录
export const barcodeBuildList = (param) => reqPost('/barcodeBuild/list', param);
export const barcodeBuildGenerate = (param) => reqPost('/barcodeBuild/generate', param);

// 条码管理
export const barcodeProductSelect = (param) => reqPost('/barcode/productSelect', param);
export const barcodeList = (param) => reqPost('/barcode/list', param);
export const barcodeBoxList = (param) => reqPost('/barcode/boxList', param);

// 入库记录
export const wareInList = (param) => reqPost('/wareIn/list', param);
export const wareInSubmit = (param) => reqPost('/wareIn/submit', param);

// 出库记录
export const wareOutList = (param) => reqPost('/wareOut/list', param);
export const wareOutOrder = (param) => reqPost('/wareOut/order', param);
export const wareOutSubmit = (param) => reqPost('/wareOut/submit', param);

// 箱码绑定记录
export const packList = (param) => reqPost('/pack/list', param);
export const packBind = (param) => reqPost('/pack/bind', param);

// 库存查询
export const inventoryProductSelect = (param) => reqPost('/inventory/productSelect', param);
export const inventoryEntityList = (param) => reqPost('/inventory/entityList', param);
export const inventoryBoxList = (param) => reqPost('/inventory/boxList', param);
export const inventoryBoxEntityList = (param) => reqPost('/inventory/boxEntityList', param);

// 条码朔源
export const traceBarCodeSearch = (param) => reqPost('/trace/barCodeSearch', param);
export const traceDetail = (param) => reqPost('/trace/detail', param);

// 产品管理
export const productList = (param) => reqPost('/product/list', param);
export const productExport = (param) => reqPost('/product/export', param);
export const productCreate = (param) => reqPost('/product/create', param);
export const productXlsxCreate = (param) => reqUpload('/product/xlsxCreate', param);
export const productUpdateDetail = (param) => reqPost('/product/updateDetail', param);
export const productUpdate = (param) => reqPost('/product/update', param);
export const productDelete = (param) => reqPost('/product/delete', param);

// 订单管理
export const wareOrderList = (param) => reqPost('/wareOrder/list', param);
export const wareOrderDetail = (param) => reqPost('/wareOrder/detail', param);
export const wareOrderUpload = (param) => reqUpload('/wareOrder/upload', param);
export const wareOrderDelete = (param) => reqPost('/wareOrder/delete', param);

// 人员管理
export const peopleList = (param) => reqPost('/people/list', param);
export const peopleCreate = (param) => reqPost('/people/create', param);
export const peopleDelete = (param) => reqPost('/people/delete', param);
